module.exports = __webpack_public_path__ + "assets/img/img315.50f20a0b.png";